module.exports = __webpack_public_path__ + "media/img/illustrations/icons/esr-warning-eaeab4438bbdc4ba4fbb8182f49e64e1.svg";